module.exports = __webpack_public_path__ + "img/127.5.f8d7f2d3.png";